import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BracketItemService {

  highlightItemEmitter = new EventEmitter();
  highlightDSEmitter = new EventEmitter();
  updateEmitter = new EventEmitter();
  scrollEmitter = new EventEmitter();
  firstRoundNameIndicator: string = '';

  private previousRoundName: string = '';
  private nextRoundName: string = '';

  constructor() { }

  setUpFirstRoundNameIndicator(roundName : string):void {
    if (!this.firstRoundNameIndicator) {
      this.firstRoundNameIndicator = roundName
    }
  }

  hover(player: number) {
    this.highlightItemEmitter.emit({
      event: 'on',
      player,
    });
  }

  leave(player: number) {
    this.highlightItemEmitter.emit({
      event: 'off',
      player,
    });
  }

  update(id: number) {
    this.updateEmitter.emit({
      event: 'update',
      id,
    });
  }

  updateAll() {
    console.debug('event updateAll has been triggered!');
    this.updateEmitter.emit({
      event: 'updateAll',
    });
  }

  scrollTo(num: number) {
    this.scrollEmitter.emit({
      event: 'scrollTo',
      num,
    });
  }

  highligh(num: number) {
    this.highlightDSEmitter.emit({
      event: 'highlight',
      num,
    });
  }

  getPreviousRoundName() {
    return this.previousRoundName;
  }

  setPreviousRoundName(nameString) {
    this.previousRoundName = nameString;
  }

  getNextRoundName() {
    return this.nextRoundName;
  }

  setNextRoundName(nameString) {
    this.nextRoundName = nameString;
  }

  updateValues(nextName) {
    if(nextName !== this.getNextRoundName()) {
      this.setPreviousRoundName(this.getNextRoundName());
      this.setNextRoundName(nextName);
    }
  }
}
